export const PUBLIC_STORAGE_URL = process.env.REACT_APP_STORAGE_PUBLIC_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
